import { useNavigate, useParams } from 'react-router-dom-v6'
import { Skeleton } from '@clouway/ui'

import { isMigratedRoleId } from '@/api/access'
import { RoleEditor } from '../components/RoleEditor'
import { useCatalogRoles, useProductStructure, useUpdateRole } from '../hooks'
import type { RoleInput } from '../types'

// /roles/:product/:roleId/edit — doubles as the preset detail view: a preset
// (custom: false) or a migrated bridge role renders the same RoleEditor in
// read-only mode instead of a separate route, since it's the same matrix
// either way.
export function EditRole() {
  const { product = '', roleId = '' } = useParams<{ product: string; roleId: string }>()
  const navigate = useNavigate()
  const { data: structure, isLoading: structureLoading } = useProductStructure(product)
  const { data: roles, isLoading: rolesLoading } = useCatalogRoles(product)
  const { mutateAsync: update } = useUpdateRole(product)
  const role = roles?.find((candidate) => candidate.id === roleId)

  if (structureLoading || rolesLoading || !structure || !role) {
    return <Skeleton className="mx-auto h-80 w-full max-w-3xl" />
  }

  const readOnly = !role.custom || isMigratedRoleId(role.id)

  const onSubmit = async (input: RoleInput) => {
    await update({ roleId, input })
    navigate('/roles')
  }

  const presets = (roles ?? []).filter((candidate) => !candidate.custom)

  return (
    <RoleEditor
      structure={structure}
      presets={presets}
      mode="edit"
      initialRole={role}
      readOnly={readOnly}
      onSubmit={onSubmit}
    />
  )
}
